<template>
    <div class="data">
        <template v-if="homeInfo">
            <div v-if="false" class="info">
                <div>
                    <span>球队数量</span>
                    <span>{{homeInfo.count.team_cnt || '0'}}</span>
                </div>
                <div>
                    <span>球员数量</span>
                    <span>{{homeInfo.count.player_cnt || '0'}}</span>
                </div>
                <div>
                    <span>球队总市值</span>
                    <span>{{homeInfo.count.team_expected || '0'}}</span>
                </div>
            </div>
            <div v-if="false" class="line"></div>
            <div v-if="false" class="tBody">
                <div class="history" v-if="homeInfo.top.length > 0">
                    <div class="title">上届冠亚军</div>
                    <div class="winInfoBox">
                        <div class="winInfo" v-for="(item,index) in 2" :key="index" @click="goTeamDetails(homeInfo.top[index].team_id, homeInfo.top[index].team_name)">
                            <div class="img">
                                <img :src="homeInfo.top[index].flag" alt="">
                            </div>
                            <div class="name">{{homeInfo.top[index].team_name}}</div>
                            <div class="record">{{homeInfo.top[index].win}}胜{{homeInfo.top[index].draw}}平{{homeInfo.top[index].fail}}负</div>
                            <div class="integral">
                                <span>积分:</span>
                                <span>{{homeInfo.top[index].integral}}</span>
                            </div>
                            <div class="txt">历史{{homeInfo.top[index].hornor_cnt}}次冠军</div>
                        </div>
                    </div>
                </div>
                <div class="schedule" v-if="homeInfo.near.length > 0">
                    <div class="title">近期赛程</div>
                    <div class="swiper">
                        <div class="tabSwiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item,index) in homeInfo.near" :key="index" @click.stop="goMatchLiveFromInte(item.match_id, 1)">
                                    <div class="match">
                                        <div class="type" :style="'color:' + item.color">{{item.league_name}}</div>
                                        <div class="status">
                                            <span><img src="../../../assets/img/database/matchIcon.png" alt=""></span>
                                            <span v-if="item.match_state == '0'">{{item.match_time.slice(5,16)}}</span>
                                            <span v-else-if="item.match_state == '1'" class="textGreen">进行中</span>
                                            <span v-else class="textRed">已结束</span>
                                        </div>
                                    </div>
                                    <div class="vsInfo">
                                        <div>
                                            <div class="nameImg">
                                                <div class="img"><img :src="item.home_icon" alt=""></div>
                                                <div class="name">
                                                    {{item.home_name}}
                                                </div>
                                            </div>
                                            <div class="score" v-if="item.match_state == '2'">{{item.home_score}}</div>
                                        </div>
                                        <div>
                                            <div class="nameImg">
                                                <div class="img"><img :src="item.away_icon" alt=""></div>
                                                <div class="name">
                                                    {{item.away_name}}
                                                </div>
                                            </div>
                                            <div class="score" v-if="item.match_state == '2'">{{item.away_score}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="eliminate" v-if="promotion">
            <div v-if="false" class="title">淘汰赛</div>
            <matchGraph :data="promotion"/>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import { Toast } from "vant"
import jsbridg from '../../../utils/jsbridg'
import { isJHApp } from "../../../utils/base"
import { getSclassBase, getScheduleChart } from "../../../api/database"
import matchGraph from '../../../components/database/matchGraph.vue'
export default {
    name: 'data',
    components: {
        matchGraph
    },
    data () {
        return {
            homeInfo: null,
            defaultTeamLogo: require("../../../assets/img/share/cup/daiding.png"),
            promotion: {
                leftFirstCol: [], // 左侧第一轮
                leftSecondCol: [], // 左侧第二轮
                leftThirdCol: {}, // 左侧第三轮
                rightFirstCol: [], // 右侧第一轮
                rightSecondCol: [], // 右侧第二轮
                rightThirdCol: {}, // 右侧第三轮
                champion: {}, // 冠军
                finish: {} // 决赛
            }
        }
    },
    created () {
        this.initData().then(() => {
            this.$nextTick(() => {
                this.mySwiper = new Swiper('.tabSwiper', {
                    slidesPerView: 2,
                    spaceBetween: 5
                    // slidesOffsetBefore: 5
                })
            })
        })
        this.getMatchGraph()
    },
    methods: {
        // 跳转球队详情
        goTeamDetails (teamId, teamName) {
            const json = {
                code: 504,
                params: `team_id=${teamId}&teamName=${teamName}`,
                jumptype: 1
            }
            if (isJHApp()) {
                jsbridg.goWebview(json);
            }
        },
        // 跳转赛事详情页
        goMatchLiveFromInte (matchid, sportid) {
            // 足球
            if (sportid === 1) {
                jsbridg.goWebview({
                    code: 5,
                    params: `matchId=${matchid}`,
                    jumptype: 1
                });
            }
        },
        async initData () {
            const param = {
                sclass_id: this.$route.query.sclass_id || '75',
                season: this.$route.query.season || '2022'
                // is_group: this.$route.query.is_group || '1'
            }
            const res = await getSclassBase(param)
            if (res.errno === 0) {
                if (res && res.data) {
                    this.homeInfo = res.data
                }
            } else {
                Toast(res.errmsg)
            }
        },
        async getMatchGraph () {
            const param = {
                sclass_id: this.$route.query.sclass_id || '75',
                season: this.$route.query.season || '2022'
            }
            const res = await getScheduleChart(param)
            if (res.errno === 0) {
                if (res && res.data) {
                    if (res.data.children.length > 0) {
                        this.dealData(res.data)
                    } else {
                        this.promotion = false
                    }
                }
            } else {
                Toast(res.errmsg)
            }
        },
        dealData (obj) {
            // 冠军
            if (!obj.winner) {
                this.promotion.champion = {
                    desc: '冠军',
                    team_logo_url: this.defaultTeamLogo
                }
            } else {
                if (obj.winner === '1') {
                    this.promotion.champion = {
                        team_logo_url: obj.team1_logo_url,
                        team_name: obj.team1_name
                    }
                } else {
                    this.promotion.champion = {
                        team_logo_url: obj.team2_logo_url,
                        team_name: obj.team2_name
                    }
                }
            };
            // 决赛
            this.promotion.finish = {
                winner: obj.winner || 0,
                status: obj.status,
                matchTime: obj.begin_time ? obj.begin_time.substring(5, 16) : '',
                team1_logo_url: obj.team1_logo_url || this.defaultTeamLogo,
                team1_name: obj.team1_name || '待定',
                team1_id: obj.team1_id,
                team2_logo_url: obj.team2_logo_url || this.defaultTeamLogo,
                team2_name: obj.team2_name || '待定',
                team2_id: obj.team2_id,
                match_info: obj.match_info || []
            };
            if (parseInt(obj.status) === 3) {
                this.promotion.finish.score = {
                    team1: obj.team1_score,
                    team2: obj.team2_score
                }
                if (obj.team1_score_2 || obj.team2_score_2) {
                    this.promotion.finish.score1 = {
                        team1: obj.team1_score_2,
                        team2: obj.team2_score_2
                    }
                }
                if (obj.match_info.home_ot_score || obj.match_info.away_ot_score) {
                    this.promotion.finish.scoreOt = {
                        team1: obj.match_info.home_ot_score,
                        team2: obj.match_info.away_ot_score
                    }
                }
                if (obj.match_info.home_pt_score || obj.match_info.away_pt_score) {
                    this.promotion.finish.scorePt = {
                        team1: obj.match_info.home_pt_score,
                        team2: obj.match_info.away_pt_score
                    }
                }
            }
            // 半决赛
            const left3 = obj.children[0];
            this.promotion.leftThirdCol = {
                winner: left3.winner || 0,
                status: left3.status,
                matchTime: left3.begin_time ? left3.begin_time.substring(5, 16) : "",
                team1_logo_url: left3.team1_logo_url || this.defaultTeamLogo,
                team1_name: left3.team1_name || '待定',
                team1_id: left3.team1_id,
                team2_logo_url: left3.team2_logo_url || this.defaultTeamLogo,
                team2_name: left3.team2_name || '待定',
                team2_id: left3.team2_id,
                match_info: left3.match_info || []
            }
            if (parseInt(left3.status) === 3) {
                this.promotion.leftThirdCol.score = {
                    team1: left3.team1_score,
                    team2: left3.team2_score
                }
                if (left3.team1_score_2 || left3.team2_score_2) {
                    this.promotion.leftThirdCol.score1 = {
                        team1: left3.team1_score_2,
                        team2: left3.team2_score_2
                    }
                }
                if (left3.match_info.home_ot_score || left3.match_info.away_ot_score) {
                    this.promotion.leftThirdCol.scoreOt = {
                        team1: left3.match_info.home_ot_score,
                        team2: left3.match_info.away_ot_score
                    }
                }
                if (left3.match_info.home_pt_score || left3.match_info.away_pt_score) {
                    this.promotion.leftThirdCol.scorePt = {
                        team1: left3.match_info.home_pt_score,
                        team2: left3.match_info.away_pt_score
                    }
                }
            }
            const right3 = obj.children[1];
            this.promotion.rightThirdCol = {
                winner: right3.winner || 0,
                status: right3.status,
                matchTime: right3.begin_time ? right3.begin_time.substring(5, 16) : '',
                team1_logo_url: right3.team1_logo_url || this.defaultTeamLogo,
                team1_name: right3.team1_name || '待定',
                team1_id: right3.team1_id,
                team2_logo_url: right3.team2_logo_url || this.defaultTeamLogo,
                team2_name: right3.team2_name || '待定',
                team2_id: right3.team2_id,
                match_info: right3.match_info || []
            }
            if (parseInt(right3.status) === 3) {
                this.promotion.rightThirdCol.score = {
                    team1: right3.team1_score,
                    team2: right3.team2_score
                }
                if (right3.team1_score_2 || right3.team2_score_2) {
                    this.promotion.rightThirdCol.score1 = {
                        team1: right3.team1_score_2,
                        team2: right3.team2_score_2
                    }
                }
                if (right3.match_info.home_ot_score || right3.match_info.away_ot_score) {
                    this.promotion.rightThirdCol.scoreOt = {
                        team1: right3.match_info.home_ot_score,
                        team2: right3.match_info.away_ot_score
                    }
                }
                if (right3.match_info.home_pt_score || right3.match_info.away_pt_score) {
                    this.promotion.rightThirdCol.scorePt = {
                        team1: right3.match_info.home_pt_score,
                        team2: right3.match_info.away_pt_score
                    }
                }
            }
            // 第二轮
            const left2 = left3.children;
            const right2 = right3.children;
            for (let i = 0; i < left2.length; i++) {
                const single = {
                    winner: left2[i].winner || 0,
                    status: left2[i].status,
                    matchTime: left2[i].begin_time ? left2[i].begin_time.substring(5, 16) : '',
                    team1_logo_url: left2[i].team1_logo_url || this.defaultTeamLogo,
                    team1_name: left2[i].team1_name || '待定',
                    team1_id: left2[i].team1_id,
                    team2_logo_url: left2[i].team2_logo_url || this.defaultTeamLogo,
                    team2_name: left2[i].team2_name || '待定',
                    team2_id: left2[i].team2_id,
                    match_info: left2[i].match_info || []
                }
                if (parseInt(left2[i].status) === 3) {
                    single.score = {
                        team1: left2[i].team1_score,
                        team2: left2[i].team2_score
                    }
                    if (left2[i].team1_score_2 || left2[i].team2_score_2) {
                        single.score1 = {
                            team1: left2[i].team1_score_2,
                            team2: left2[i].team2_score_2
                        }
                    }
                    if (left2[i].match_info.home_ot_score || left2[i].match_info.away_ot_score) {
                        single.scoreOt = {
                            team1: left2[i].match_info.home_ot_score,
                            team2: left2[i].match_info.away_ot_score
                        }
                    }
                    if (left2[i].match_info.home_pt_score || left2[i].match_info.away_pt_score) {
                        single.scorePt = {
                            team1: left2[i].match_info.home_pt_score,
                            team2: left2[i].match_info.away_pt_score
                        }
                    }
                }
                this.promotion.leftSecondCol.push(single)
            }
            for (let i = 0; i < right2.length; i++) {
                const single = {
                    winner: right2[i].winner || 0,
                    status: right2[i].status,
                    matchTime: right2[i].begin_time ? right2[i].begin_time.substring(5, 16) : '',
                    team1_logo_url: right2[i].team1_logo_url || this.defaultTeamLogo,
                    team1_name: right2[i].team1_name || '待定',
                    team1_id: right2[i].team1_id,
                    team2_logo_url: right2[i].team2_logo_url || this.defaultTeamLogo,
                    team2_name: right2[i].team2_name || '待定',
                    team2_id: right2[i].team2_id,
                    match_info: right2[i].match_info || []
                }
                if (parseInt(right2[i].status) === 3) {
                    single.score = {
                        team1: right2[i].team1_score,
                        team2: right2[i].team2_score
                    }
                    if (right2[i].team1_score_2 || right2[i].team2_score_2) {
                        single.score1 = {
                            team1: right2[i].team1_score_2,
                            team2: right2[i].team2_score_2
                        }
                    }
                    if (right2[i].match_info.home_ot_score || right2[i].match_info.away_ot_score) {
                        single.scoreOt = {
                            team1: right2[i].match_info.home_ot_score,
                            team2: right2[i].match_info.away_ot_score
                        }
                    }
                    if (right2[i].match_info.home_pt_score || right2[i].match_info.away_pt_score) {
                        single.scorePt = {
                            team1: right2[i].match_info.home_pt_score,
                            team2: right2[i].match_info.away_pt_score
                        }
                    }
                }
                this.promotion.rightSecondCol.push(single)
            }
            // 第一轮
            for (let i = 0; i < left2.length; i++) {
                for (let j = 0; j < left2[i].children.length; j++) {
                    const single = {
                        winner: left2[i].children[j].winner || 0,
                        status: left2[i].children[j].status,
                        // score: parseInt(left2[i].children[j].status) === 3 ? left2[i].children[j].team1_score + '-' + left2[i].children[j].team2_score : '',
                        // score1: (left2[i].children[j].team1_score_2 && left2[i].children[j].team2_score_2) ? left2[i].children[j].team1_score_2 + '-' + left2[i].children[j].team2_score_2 : '',
                        matchTime: left2[i].children[j].begin_time ? left2[i].children[j].begin_time.substring(5, 16) : '',
                        team1_logo_url: left2[i].children[j].team1_logo_url || this.defaultTeamLogo,
                        team1_name: left2[i].children[j].team1_name || '待定',
                        team1_id: left2[i].children[j].team1_id,
                        team2_logo_url: left2[i].children[j].team2_logo_url || this.defaultTeamLogo,
                        team2_name: left2[i].children[j].team2_name || '待定',
                        team2_id: left2[i].children[j].team2_id,
                        match_info: left2[i].children[j].match_info || []
                    }
                    if (parseInt(left2[i].children[j].status) === 3) {
                        single.score = {
                            team1: left2[i].children[j].team1_score,
                            team2: left2[i].children[j].team2_score
                        }
                        if (left2[i].children[j].team1_score_2 || left2[i].children[j].team2_score_2) {
                            single.score1 = {
                                team1: left2[i].children[j].team1_score_2,
                                team2: left2[i].children[j].team2_score_2
                            }
                        }
                        if (left2[i].children[j].match_info.home_ot_score || left2[i].children[j].match_info.away_ot_score) {
                            single.scoreOt = {
                                team1: left2[i].children[j].match_info.home_ot_score,
                                team2: left2[i].children[j].match_info.away_ot_score
                            }
                        }
                        if (left2[i].children[j].match_info.home_pt_score || left2[i].children[j].match_info.away_pt_score) {
                            single.scorePt = {
                                team1: left2[i].children[j].match_info.home_pt_score,
                                team2: left2[i].children[j].match_info.away_pt_score
                            }
                        }
                    }
                    this.promotion.leftFirstCol.push(single)
                }
            }
            for (let i = 0; i < right2.length; i++) {
                for (let j = 0; j < right2[i].children.length; j++) {
                    const single = {
                        winner: right2[i].children[j].winner || 0,
                        status: right2[i].children[j].status,
                        // score: parseInt(right2[i].children[j].status) === 3 ? right2[i].children[j].team1_score + '-' + right2[i].children[j].team2_score : '',
                        // score1: (right2[i].children[j].team1_score_2 && right2[i].children[j].team2_score_2) ? right2[i].children[j].team1_score_2 + '-' + right2[i].children[j].team2_score_2 : '',
                        matchTime: right2[i].children[j].begin_time ? right2[i].children[j].begin_time.substring(5, 16) : '',
                        team1_logo_url: right2[i].children[j].team1_logo_url || this.defaultTeamLogo,
                        team1_name: right2[i].children[j].team1_name || '1/8 决赛',
                        team1_id: right2[i].children[j].team1_id,
                        team2_logo_url: right2[i].children[j].team2_logo_url || this.defaultTeamLogo,
                        team2_name: right2[i].children[j].team2_name || '1/8 决赛',
                        team2_id: right2[i].children[j].team2_id,
                        match_info: right2[i].children[j].match_info || []
                    }
                    if (parseInt(right2[i].status) === 3) {
                        single.score = {
                            team1: right2[i].children[j].team1_score,
                            team2: right2[i].children[j].team2_score
                        }
                        if (right2[i].children[j].team1_score_2 && right2[i].children[j].team2_score_2) {
                            single.score1 = {
                                team1: right2[i].children[j].team1_score_2,
                                team2: right2[i].children[j].team2_score_2
                            }
                        }
                        if (right2[i].children[j].match_info.home_ot_score || right2[i].children[j].match_info.away_ot_score) {
                            single.scoreOt = {
                                team1: right2[i].children[j].match_info.home_ot_score,
                                team2: right2[i].children[j].match_info.away_ot_score
                            }
                        }
                        if (right2[i].children[j].match_info.home_pt_score || right2[i].children[j].match_info.away_pt_score) {
                            single.scorePt = {
                                team1: right2[i].children[j].match_info.home_pt_score,
                                team2: right2[i].children[j].match_info.away_pt_score
                            }
                        }
                    }
                    this.promotion.rightFirstCol.push(single)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/swiper.min.css';
.data {
    min-height: 100vh;
    .line {
        height: 3px;
        background: #F5F5F5;
    }
    .info {
        padding: 0 12px;
        div {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #eee;
            &:last-child {
                border: none;
            }
            span {
                font-size: 12px;
                font-weight: 400;
                &:first-child {
                    color: #666666;
                }
                &:last-child {
                    color: #333333;
                }
            }
        }
    }
    .title {
        height: 40px;
        font-size: 13px;
        font-weight: bold;
        color: #333333;
        line-height: 40px;
    }
    .tBody {
        margin-top: 8px;
        padding: 0 12px;
        .history {
            width: 100%;
            .winInfoBox {
                display: flex;
                justify-content: space-evenly;
                .winInfo {
                    width: 111px;
                    height: 133px;
                    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.05);
                    border: 1px solid #EEEEEE;
                    border-radius: 4px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;
                    padding: 5px 0;
                    .img {
                        width: 22px;
                        height: 31px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .name {
                        font-size: 13px;
                        font-weight: 400;
                        color: #333333;
                    }
                    .record {
                        font-size: 10px;
                        font-weight: 400;
                        color: #333333;
                    }
                    .integral {
                        span {
                            font-size: 10px;
                            font-weight: 400;
                            color: #333333;
                            &:last-child {
                                color: #FF5048;
                            }
                        }
                    }
                    .txt {
                        font-size: 10px;
                        font-weight: 400;
                        color: #7D7D7D;
                    }
                }
            }
        }
        .schedule {
            margin-top: 5px;
            .swiper {
                .tabSwiper {
                    overflow: hidden;
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 169px;
                            // height: 90px;
                            box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.05);
                            border: 1px solid #EEEEEE;
                            border-radius: 5px;
                            // padding: 10px;
                            display: flex;
                            flex-direction: column;
                            padding: 10px;
                            box-sizing: border-box;
                            .match {
                                width: 100%;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                .type {
                                    font-size: 11px;
                                    font-weight: 400;
                                    // color: #FF5048;
                                }
                                .status {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    span {
                                        &:first-child {
                                            width: 16px;
                                            height: 12px;
                                            img {
                                                width: 100%;
                                                height: 100%;
                                                margin-bottom: 2px;
                                            }
                                        }
                                        &:last-child {
                                            font-size: 11px;
                                            font-weight: 400;
                                            margin-left: 5px;
                                        }
                                    }
                                    .textGreen {
                                        color: #43A000;
                                    }
                                    .textRed {
                                        color: #FF5048;
                                    }
                                }
                            }
                            .vsInfo {
                                margin-top: 5px;
                                flex: 1;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                div {
                                    width: 100%;
                                    height: 22px;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    .nameImg {
                                        flex: 1;
                                        display: flex;
                                        justify-content: center;
                                        .img {
                                            width: 12px;
                                            height: 12px;
                                            img {
                                                width: 100%;
                                                height: 100%;
                                            }
                                        }
                                        .name {
                                            font-size: 13px;
                                            font-weight: 600;
                                            color: #333333;
                                            margin-left: 5px;
                                        }
                                    }
                                    .score {
                                        width: 15px;
                                        font-size: 15px;
                                        font-weight: 600;
                                        text-align: right;
                                        color: #43A000;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .eliminate {
        // margin-top: 25px;
        padding: 25px 10px 0 10px;
    }
}
</style>
